// extracted by mini-css-extract-plugin
export default {"container":"JQ-z","modal":"KQ-z","dimensions":"LQ-z","brandName":"MQ-z","productName":"NQ-z","labelValue":"OQ-z","recipientEmail":"PQ-z","recommendedFit":"QQ-z","hiddenField":"RQ-z"};